module.exports = __webpack_public_path__ + "img/frame_leaderboard.257c0275.svg";